// import React, { useEffect, useState } from 'react';
// import { Bar } from 'react-chartjs-2';
// import 'chart.js/auto';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth';
// import axios from 'axios';


// const AppointmentListPage = () => {
//   const [appointments, setAppointments] = useState([]);
//   const { user, token } = useAuth();
//   const doctorId = user?.id;

// console.log(user,token); // Should include the right role

// useEffect(() => {
//   const fetchAppointments = async () => {
//     try {
//       const response = await axios.get(`${API_PATH}/appointments/doctor/${doctorId}`, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//       setAppointments(response.data);
//     } catch (err) {
//       console.error('Failed to fetch appointments', err);
//     }
//   };

//   if (doctorId && token) {
//     fetchAppointments();
//   }
// }, [doctorId, token]);

//   return (
//     <div className="container mt-4">
//       <div className="row mb-4">


//         <div className="col-md-12 bg-white shadow rounded p-3">
//           <h5>Appointments</h5>
//           <div className="table-responsive">
//             <table className="table table-hover">
//               <thead className="table-light">
//                 <tr>
//                   <th>#</th>
//                   <th>Patient</th>
//                   <th>Email</th>
//                   <th>Time</th>
//                   <th>Reason</th>
//                   <th>Type</th>
//                   <th>Status</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {appointments.map((appt, index) => (
//                   <tr key={appt.id}>
//                     <td>{index + 1}</td>
//                     <td>{`${appt.patientFirstName} ${appt.patientLastName}`}</td>
//                     <td>{appt.patientEmail}</td>
//                     <td>{`${appt.startTime} - ${appt.endTime}`}</td>
//                     <td>{appt.reason}</td>
//                     <td>
//                       <span className={`badge ${appt.appointmentType === 'General' ? 'bg-warning' : 'bg-info'}`}>
//                         {appt.appointmentType}
//                       </span>
//                     </td>
//                     <td>
//                       <span className={`badge ${appt.status === 'Scheduled' ? 'bg-success' : 'bg-secondary'}`}>
//                         {appt.status}
//                       </span>
//                     </td>
//                     <td>
//                       <button className="btn btn-sm btn-outline-primary">View</button>
//                     </td>
//                   </tr>
//                 ))}
//                 {appointments.length === 0 && (
//                   <tr>
//                     <td colSpan="8" className="text-center text-muted">No appointments found</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AppointmentListPage;

// import React, { useEffect, useState } from 'react';
// import { Modal, Button, Form } from 'react-bootstrap';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import moment from 'moment';
// import { useNavigate } from 'react-router-dom';

// const AppointmentListPage = () => {
//   const navigate = useNavigate();
//   const [appointments, setAppointments] = useState([]);
//   const [filteredAppointments, setFilteredAppointments] = useState([]);
//   const [search, setSearch] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showModal, setShowModal] = useState(false);
//   const [showAttendeeModal, setShowAttendeeModal] = useState(false);
//   const [selectedAppt, setSelectedAppt] = useState(null);
//   const [nameFilter, setNameFilter] = useState('');
//   const [numberFilter, setNumberFilter] = useState('');
//   const [extraDetails, setExtraDetails] = useState({
//   gender: '',
//   dateOfBirth: '',

// });




// const [slotOptions, setSlotOptions] = useState([]);

// useEffect(() => {
//   const loadSlots = async () => {
//     try {
//       const res = await axios.get(`${API_PATH}/doctors/${doctorId}/schedule/list`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//     const slots = res.data.flatMap(s =>
//   s.appointmentSlots.map(sl => ({
//     slotId: sl.slotId,
//     scheduleId: s.id,
//     appointmentDate: s.scheduleDate,
//     startTime: sl.startTime,
//     endTime: sl.endTime,
//     status: sl.status // include status here
//   }))
// );
//       setSlotOptions(slots);
//     } catch (err) {
//       Swal.fire('Error', 'Failed to load slots', 'error');
//     }
//   };

//   if (doctorId && token) loadSlots();
// }, [doctorId, token]);


//   // const [formData, setFormData] = useState({
//   //   patientFirstName: '',
//   //   patientLastName: '',
//   //   patientAddress: '',
//   //   patientEmail: '',
//   //   reason: '',
//   //   appointmentType: 'General',
//   //   status: 'Scheduled',
//   //   startTime: '',
//   //   endTime: ''
//   // });


//   const [formData, setFormData] = useState({
//   patientFirstName: '',
//   patientLastName: '',
//   patientEmail: '',
//   patientNumber: '',
//   patientAddress: '',
//   reason: '',
//   appointmentType: 'General',
//   status: 'Scheduled',
//   slotId: '',
//   appointmentDate: '',
//   startTime: '',
//   endTime: ''
// });



// const handleAddAppointment = async () => {
//   try {
//     await axios.post(`${API_PATH}/appointments/book`, {
//       ...formData


//     }, {
//       headers: { Authorization: `Bearer ${token}` }
//     });
//     Swal.fire('Success', 'Appointment booked', 'success');
//     handleCloseModal();
//     // optionally refresh appointments & slots
//   } catch (err) {
//     Swal.fire('Error', 'Failed to book appointment', 'error');
//   }
// };

//   const { user, token } = useAuth();
//   const doctorId = user?.id;
//   const itemsPerPage = 5;



//   useEffect(() => {
//   const fetchAppointments = async () => {
//     try {
//       const response = await axios.get(`${API_PATH}/appointments/doctor/${doctorId}`, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       });

//       // ✅ Filter appointments without prescriptions
//       const filtered = response.data.filter(appt => !appt.prescriptionDone);
//       setAppointments(filtered);

//     } catch (err) {
//       Swal.fire('Error', 'Failed to fetch appointments', 'error');
//     }
//   };

//   if (doctorId && token) {
//     fetchAppointments();
//   }
// }, [doctorId, token]);



//   useEffect(() => {
//     let filtered = appointments.filter(appt => {
//       const fullName = `${appt.patientFirstName} ${appt.patientLastName}`.toLowerCase();
//       return (
//         fullName.includes(search.toLowerCase()) &&
//         fullName.includes(nameFilter.toLowerCase()) &&
//         appt.patientNumber?.includes(numberFilter)
//       );
//     });

//     if (dateFilter === 'today') {
//       filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment(), 'day'));
//     } else if (dateFilter === 'tomorrow') {
//       filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment().add(1, 'day'), 'day'));
//     } else if (dateFilter === 'yesterday') {
//       filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment().subtract(1, 'day'), 'day'));
//     }

//     setFilteredAppointments(filtered);
//     setCurrentPage(1);
//   }, [appointments, search, nameFilter, numberFilter, dateFilter]);





//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredAppointments.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage);

//   const handleShowModal = () => setShowModal(true);
//   const handleCloseModal = () => setShowModal(false);

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // const handleAddAppointment = async () => {
//   //   try {
//   //     await axios.post(`${API_PATH}/appointments/book`, {
//   //       ...formData,
//   //       doctorId,
//   //       appointmentDate: moment().format('YYYY-MM-DD') // placeholder
//   //     }, {
//   //       headers: {
//   //         Authorization: `Bearer ${token}`
//   //       }
//   //     });
//   //     Swal.fire('Success', 'Appointment added', 'success');
//   //     handleCloseModal();
//   //   } catch (err) {
//   //     Swal.fire('Error', 'Failed to add appointment', 'error');
//   //   }
//   // };
//    const ensureSeconds = (dateStr) => {
//     if (!dateStr) return '';
//     const date = new Date(dateStr);
//     const yyyy = date.getFullYear();
//     const MM = String(date.getMonth() + 1).padStart(2, '0');
//     const dd = String(date.getDate()).padStart(2, '0');
//     const hh = String(date.getHours()).padStart(2, '0');
//     const mm = String(date.getMinutes()).padStart(2, '0');
//     const ss = String(date.getSeconds()).padStart(2, '0');
//     return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
//   };
//   const handleAttendee = async (appt) => {
//     try {
//       const truncate = (val, limit = 10) => val ? val.substring(0, limit) : '';
//       const response = await axios.post(`${API_PATH}/patients`, {
//         firstName: truncate(appt.patientFirstName),
//         lastName: truncate(appt.patientLastName),
//         dateOfBirth: appt.dateOfBirth || null,
//         gender: truncate(appt.gender || extraDetails.gender || 'Unknown'),
//         contacts: [
//           {
//             type: 'Phone',
//             value: extraDetails.mobileNumber || appt.patientNumber || ''
//           },
//           ...(appt.patientEmail ? [{ type: 'Email', value: appt.patientEmail }] : [])
//         ],
//         registrationDate: ensureSeconds(new Date()),
//         attendingDoctorId: doctorId
//       }, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       const patientId = response.data?.id;
//       Swal.fire('Success', 'Patient added successfully', 'success');

//       if (patientId) {
//         navigate(`/doctor/home/patients/${patientId}/prescriptions`);
//       }
//     } catch (error) {
//       console.error(error);
//       Swal.fire('Error', 'Failed to add patient', 'error');
//     }
//   };



//   return (
//     <div className="container p-4 bg-light " >
//       <div className="d-flex justify-content-between align-items-center mb-3 ">
//         <h4>🗓 Appointments</h4>
//         <div className='row'>
//           <div className='col-md-2'>
//           <input
//             type="text"
//             className="form-control"
//             placeholder="Filter by Name"
//             value={nameFilter}
//             onChange={(e) => setNameFilter(e.target.value)}
//           />
//           </div>
//           <div className='col-md-2'>
//           <input
//             type="text"
//             className="form-control"
//             placeholder="Filter by Number"
//             value={numberFilter}
//             onChange={(e) => setNumberFilter(e.target.value)}
//           />
//           </div>
//           <div className='col-md-3'>
//           <input
//             type="date"
//             className="form-control d-inline-block w-auto me-2"
//             onChange={(e) => setSearch(e.target.value)}
//           />
//           </div>
//           <div className='col-md-2'>
//           <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} className="form-select d-inline-block w-auto me-2">
//             <option value="all">All</option>
//             <option value="today">Today</option>
//             <option value="tomorrow">Tomorrow</option>
//             <option value="yesterday">Yesterday</option>
//           </select>
//           </div>
//           <div className='col-md-3'>
//           <Button onClick={handleShowModal} variant="outline-primary" size="sm" style={{height:"40px"}}>+ Add Appointment</Button>
//         </div>
//         </div>
//       </div>

//       <div className="table-responsive">
//         <table className=" table-striped table-bordered">
//           <thead className="tableborder">
//             <tr>
//               <th className='tableborder'>#</th>
//               <th className='tableborder'>Patient</th>
//               <th className='tableborder'>Email</th>
//               <th>Mobile No</th>
//               <th>Time</th>
//               <th>Reason</th>
//               <th>Address</th>
//                <th>Appointment Date</th>
//               <th>Type</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentItems.map((appt, index) => (
//               <tr key={appt.id} className='datahover'>
//                 <td>{indexOfFirstItem + index + 1}</td>
//                 <td>{`${appt.patientFirstName} ${appt.patientLastName}`}</td>
//                 <td>{appt.patientEmail}</td>
//                 <td>{appt.patientNumber}</td>
//                 <td>{`${appt.startTime} - ${appt.endTime}`}</td>
//                 <td>{appt.reason}</td>
//                 <td>{appt.patientAddress}</td>
//                 <td>{appt.appointmentDate}</td>
//                 <td><span className="badge bg-info">{appt.appointmentType}</span></td>
//                 <td><span className={`badge ${appt.status === 'Scheduled' ? 'bg-success' : 'bg-secondary'}`}>{appt.status}</span></td>
//                 <td><Button variant="outline-primary" size="sm">Edit</Button>

//                 <Button
//   variant="outline-success"
//   size="sm"
//   disabled={appt.prescriptionDone}
//   title={appt.prescriptionDone ? "Prescription already completed" : ""}
//   onClick={() => {
//     const needsExtra = !appt.gender || !appt.dateOfBirth || !appt.patientAddress;
//     if (needsExtra) {
//       setSelectedAppt(appt);
//       setExtraDetails({
//         gender: '',
//         dateOfBirth: '',
//         patientAddress: ''
//       });
//       setShowAttendeeModal(true);
//     } else {
//       handleAttendee(appt);
//     }
//   }}
// >
//   Attendee
// </Button>



//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className="d-flex justify-content-center mt-3">
//         <Button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} className="me-2 btn-color border-0">Previous</Button>
//         <span className="align-self-center">Page {currentPage} of {totalPages}</span>
//         <Button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} className="ms-2 btn-color border-0">Next</Button>
//       </div>

//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title>Add Appointment</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Control name="patientFirstName" className="mb-2" placeholder="First Name" onChange={handleInputChange} />
//             <Form.Control name="patientLastName" className="mb-2" placeholder="Last Name" onChange={handleInputChange} />
//             <Form.Control name="patientEmail" type="email" className="mb-2" placeholder="Email" onChange={handleInputChange} />
//             <Form.Control name="reason" className="mb-2" placeholder="Reason" onChange={handleInputChange} />
//             <Form.Select name="appointmentType" className="mb-2" onChange={handleInputChange}>
//               <option value="General">General</option>
//               <option value="Consultation">Consultation</option>
//             </Form.Select>
//             <Form.Control name="startTime" type="time" className="mb-2" placeholder="Start Time" onChange={handleInputChange} />
//             <Form.Control name="endTime" type="time" className="mb-2" placeholder="End Time" onChange={handleInputChange} />
//             <Form.Select
//   name="slotId"
//   className="mb-2"
//   value={formData.slotId || ''}
//   onChange={(e) => {
//     const selected = slotOptions.find(o => o.slotId === +e.target.value);
//     if (selected) {
//       setFormData({
//         ...formData,
//         slotId: selected.slotId,
//         appointmentDate: selected.appointmentDate,
//         startTime: selected.startTime,
//         endTime: selected.endTime,
//         status: selected.status // set status here automatically
//       });
//     }
//   }}
// >
//   <option value="">Select Slot</option>
//   {slotOptions.map(o => (
//     <option key={o.slotId} value={o.slotId}>
//       {o.appointmentDate} — {o.startTime}–{o.endTime}
//     </option>
//   ))}
// </Form.Select>

//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
//           <Button variant="success" onClick={handleAddAppointment}>Save</Button>
//         </Modal.Footer>
//       </Modal>
//       <Modal show={showAttendeeModal} onHide={() => setShowAttendeeModal(false)}>
//   <Modal.Header closeButton>
//     <Modal.Title>Complete Missing Details</Modal.Title>
//   </Modal.Header>
//   <Modal.Body>
//     <Form>
//       <Form.Select
//         className="mb-2"
//         value={extraDetails.gender}
//         onChange={(e) => setExtraDetails({ ...extraDetails, gender: e.target.value })}
//       >
//         <option value="">Select Gender</option>
//         <option value="Male">Male</option>
//         <option value="Female">Female</option>
//         <option value="Other">Other</option>
//       </Form.Select>
//       <Form.Control
//         type="date"
//         className="mb-2"
//         placeholder="Date of Birth"
//         value={extraDetails.dateOfBirth}
//         onChange={(e) => setExtraDetails({ ...extraDetails, dateOfBirth: e.target.value })}
//       />

//     </Form>
//   </Modal.Body>
//   <Modal.Footer>
//     <Button variant="secondary" onClick={() => setShowAttendeeModal(false)}>Cancel</Button>
//     <Button
//       variant="success"
//       onClick={() => {
//         handleAttendee({
//           ...selectedAppt,
//           gender: extraDetails.gender,
//           dateOfBirth: extraDetails.dateOfBirth,
//           patientAddress: extraDetails.patientAddress
//         });
//         setShowAttendeeModal(false);
//       }}
//     >
//       Save & Continue
//     </Button>
//   </Modal.Footer>
// </Modal>

//     </div>
//   );
// };

// export default AppointmentListPage;








// import React, { useEffect, useState } from 'react';
// import { Modal, Button, Form } from 'react-bootstrap';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import moment from 'moment';
// import { useNavigate } from 'react-router-dom';

// const AppointmentListPage = () => {
//   const navigate = useNavigate();
//   const { user, token } = useAuth();
//   const doctorId = user?.id;
//   const itemsPerPage = 5;

//   const [appointments, setAppointments] = useState([]);
//   const [filteredAppointments, setFilteredAppointments] = useState([]);
//   const [search, setSearch] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showModal, setShowModal] = useState(false);
//   const [showAttendeeModal, setShowAttendeeModal] = useState(false);
//   const [selectedAppt, setSelectedAppt] = useState(null);
//   const [nameFilter, setNameFilter] = useState('');
//   const [numberFilter, setNumberFilter] = useState('');
//   const [extraDetails, setExtraDetails] = useState({
//     gender: '',
//     dateOfBirth: '',
//     patientAddress: ''
//   });

//   const [slotOptions, setSlotOptions] = useState([]);
//   const [selectedSlotStatus, setSelectedSlotStatus] = useState('');


//   const [formData, setFormData] = useState({
//     patientFirstName: '',
//     patientLastName: '',
//     patientEmail: '',
//     patientNumber: '',
//     patientAddress: '',
//     reason: '',
//     appointmentType: 'General',
//     status: 'Scheduled',
//     slotId: '',
//     appointmentDate: '',
//     startTime: '',
//     endTime: ''
//   });

//   useEffect(() => {
//     const loadSlots = async () => {
//       try {
//         const res = await axios.get(`${API_PATH}/doctors/${doctorId}/schedule/list`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const slots = res.data.flatMap(s =>
//           s.appointmentSlots.map(sl => ({
//             slotId: sl.slotId,
//             scheduleId: s.id,
//             appointmentDate: s.scheduleDate,
//             startTime: sl.startTime,
//             endTime: sl.endTime,
//             status: sl.status
//           }))
//         );
//         setSlotOptions(slots);
//       } catch (err) {
//         Swal.fire('Error', 'Failed to load slots', 'error');
//       }
//     };

//     if (doctorId && token) loadSlots();
//   }, [doctorId, token]);

//   const handleAddAppointment = async () => {
//     if (!doctorId) {
//       Swal.fire('Error', 'Please fill all required fields including patient number and address', 'warning');
//       return;
//     }

//     try {
//       await axios.post(`${API_PATH}/appointments/book`, {
//         ...formData,
//         doctorId
//       }, {
//         headers: { Authorization: `Bearer ${token}` }
//       });

//       Swal.fire('Success', 'Appointment booked', 'success');
//       handleCloseModal();
//     } catch (err) {
//       Swal.fire('Error', err.response?.data?.message || 'Failed to book appointment', 'error');
//     }
//   };

//   useEffect(() => {
//     const fetchAppointments = async () => {
//       try {
//         const response = await axios.get(`${API_PATH}/appointments/doctor/${doctorId}`, {
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         });
//         const filtered = response.data.filter(appt => !appt.prescriptionDone);
//         setAppointments(filtered);
//       } catch (err) {
//         Swal.fire('Error', 'Failed to fetch appointments', 'error');
//       }
//     };

//     if (doctorId && token) {
//       fetchAppointments();
//     }
//   }, [doctorId, token]);

//   const handleUpdateAppointment = async () => {
//     if ( !doctorId) {
//       Swal.fire('Error', 'Please fill all required fields', 'warning');
//       return;
//     }

//     try {
//       await axios.patch(`${API_PATH}/appointments/${formData.id}`, {
//         ...formData,
//         doctorId
//       }, {
//         headers: { Authorization: `Bearer ${token}` }
//       });

//       Swal.fire('Success', 'Appointment updated', 'success');
//       handleCloseModal();
//     } catch (err) {
//       Swal.fire('Error', err.response?.data?.message || 'Failed to update appointment', 'error');
//     }
//   };

//   const handleEditClick = (appointment) => {
//     setFormData({
//       ...appointment
//     });
//     setShowModal(true);
//   };


//   const handleDeleteAppointment = async (appointmentId) => {
//     const result = await Swal.fire({
//       title: 'Are you sure?',
//       text: 'This will permanently delete the appointment!',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonText: 'Yes, delete it!',
//     });

//     if (result.isConfirmed) {
//       try {
//         await axios.delete(`${API_PATH}/appointments/${appointmentId}`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });

//         Swal.fire('Deleted!', 'Appointment has been deleted.', 'success');
       
//       } catch (err) {
//         Swal.fire('Error', err.response?.data?.message || 'Failed to delete appointment', 'error');
//       }
//     }
//   };

//   useEffect(() => {
//     let filtered = appointments.filter(appt => {
//       const fullName = `${appt.patientFirstName} ${appt.patientLastName}`.toLowerCase();
//       return (
//         fullName.includes(search.toLowerCase()) &&
//         fullName.includes(nameFilter.toLowerCase()) &&
//         appt.patientNumber?.includes(numberFilter)
//       );
//     });

//     if (dateFilter === 'today') {
//       filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment(), 'day'));
//     } else if (dateFilter === 'tomorrow') {
//       filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment().add(1, 'day'), 'day'));
//     } else if (dateFilter === 'yesterday') {
//       filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment().subtract(1, 'day'), 'day'));
//     }

//     setFilteredAppointments(filtered);
//     setCurrentPage(1);
//   }, [appointments, search, nameFilter, numberFilter, dateFilter]);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredAppointments.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage);

//   const handleShowModal = () => setShowModal(true);
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setFormData({
//       patientFirstName: '',
//       patientLastName: '',
//       patientEmail: '',
//       patientNumber: '',
//       patientAddress: '',
//       reason: '',
//       appointmentType: 'General',
//       status: 'Scheduled',
//       slotId: '',
//       appointmentDate: '',
//       startTime: '',
//       endTime: ''
//     });
//     setSelectedSlotStatus('');
//   };

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const ensureSeconds = (dateStr) => {
//     if (!dateStr) return '';
//     const date = new Date(dateStr);
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
//       date.getDate()
//     ).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(
//       date.getMinutes()
//     ).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
//   };

//   const handleAttendee = async (appt) => {
//     try {
//       const truncate = (val, limit = 10) => (val ? val.substring(0, limit) : '');
//       const response = await axios.post(`${API_PATH}/patients`, {
//         firstName: truncate(appt.patientFirstName),
//         lastName: truncate(appt.patientLastName),
//         dateOfBirth: appt.dateOfBirth || null,
//         gender: truncate(appt.gender || extraDetails.gender || 'Unknown'),
//         contacts: [
//           {
//             type: 'Phone',
//             value: extraDetails.mobileNumber || appt.patientNumber || ''
//           },
//           ...(appt.patientEmail ? [{ type: 'Email', value: appt.patientEmail }] : [])
//         ],
//         registrationDate: ensureSeconds(new Date()),
//         attendingDoctorId: doctorId
//       }, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       const patientId = response.data?.id;
//       Swal.fire('Success', 'Patient added successfully', 'success');
//       if (patientId) {
//         navigate(`/doctor/home/patients/${patientId}/prescriptions`);
//       }
//     } catch (error) {
//       Swal.fire('Error', 'Failed to add patient', 'error');
//     }
//   };

//   return (
//     <div className="container p-4 bg-light">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h4>🗓 Appointments</h4>
//         <div className="row w-100">
//           <div className="col-md-2">
//             <input type="text" className="form-control" placeholder="Filter by Name" value={nameFilter} onChange={(e) => setNameFilter(e.target.value)} />
//           </div>
//           <div className="col-md-2">
//             <input type="text" className="form-control" placeholder="Filter by Number" value={numberFilter} onChange={(e) => setNumberFilter(e.target.value)} />
//           </div>
//           <div className="col-md-3">
//             <input type="date" className="form-control" onChange={(e) => setSearch(e.target.value)} />
//           </div>
//           <div className="col-md-2">
//             <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} className="form-select">
//               <option value="all">All</option>
//               <option value="today">Today</option>
//               <option value="tomorrow">Tomorrow</option>
//               <option value="yesterday">Yesterday</option>
//             </select>
//           </div>
//           <div className="col-md-3">
//             <Button onClick={handleShowModal} variant="outline-primary" size="sm" style={{ height: '40px' }}>+ Add Appointment</Button>
//           </div>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="table-responsive">
//         <table className="table table-striped table-bordered">
//           <thead className="tableborder">
//             <tr>
//               <th>#</th>
//               <th>Patient</th>
//               <th>Email</th>
//               <th>Mobile No</th>
//               <th>Time</th>
//               <th>Reason</th>
//               <th>Address</th>
//               <th>Appointment Date</th>
//               <th>Type</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentItems.map((appt, index) => (
//               <tr key={appt.id}>
//                 <td>{indexOfFirstItem + index + 1}</td>
//                 <td>{`${appt.patientFirstName} ${appt.patientLastName}`}</td>
//                 <td>{appt.patientEmail}</td>
//                 <td>{appt.patientNumber}</td>
//                 <td>{`${appt.startTime} - ${appt.endTime}`}</td>
//                 <td>{appt.reason}</td>
//                 <td>{appt.patientAddress}</td>
//                 <td>{appt.appointmentDate}</td>
//                 <td><span className="badge bg-info">{appt.appointmentType}</span></td>
//                 <td><span className={`badge ${appt.status === 'Scheduled' ? 'bg-success' : 'bg-secondary'}`}>{appt.status}</span></td>
//                 <td>
//                   {/* <Button variant="outline-primary" size="sm">Edit</Button>{' '}
//                   <Button
//                     variant="outline-success"
//                     size="sm"
//                     disabled={appt.prescriptionDone}
//                     title={appt.prescriptionDone ? "Prescription already completed" : ""}
//                     onClick={() => {
//                       const needsExtra = !appt.gender || !appt.dateOfBirth || !appt.patientAddress;
//                       if (needsExtra) {
//                         setSelectedAppt(appt);
//                         setExtraDetails({
//                           gender: '',
//                           dateOfBirth: '',
//                           patientAddress: ''
//                         });
//                         setShowAttendeeModal(true);
//                       } else {
//                         handleAttendee(appt);
//                       }
//                     }}
//                   >
//                     Attendee
//                   </Button> */}

//                   <Button
//                     variant="warning"
//                     size="sm"
//                     onClick={() => handleEditClick(appointments)}
//                   >
//                     Edit
//                   </Button>
//                   <Button
//                     variant="danger"
//                     size="sm"
//                     className="ms-2"
//                     onClick={() => handleDeleteAppointment(appointments.id)}
//                   >
//                     Delete
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="d-flex justify-content-center mt-3">
//         <Button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} className="me-2">Previous</Button>
//         <span>Page {currentPage} of {totalPages}</span>
//         <Button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} className="ms-2">Next</Button>
//       </div>

//       {/* Add Modal */}
//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title>Add Appointment</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Control name="patientFirstName" className="mb-2" placeholder="First Name" onChange={handleInputChange} />
//             <Form.Control name="patientLastName" className="mb-2" placeholder="Last Name" onChange={handleInputChange} />
//             <Form.Control name="patientEmail" type="email" className="mb-2" placeholder="Email" onChange={handleInputChange} />
//             <Form.Control name="reason" className="mb-2" placeholder="Reason" onChange={handleInputChange} />
//             <Form.Control
//               name="patientNumber"
//               className="mb-2"
//               placeholder="Mobile Number"
//               onChange={handleInputChange}
//               required
//             />
//             <Form.Control
//               name="patientAddress"
//               className="mb-2"
//               placeholder="Address"
//               onChange={handleInputChange}
//               required
//             />

//             <Form.Select name="appointmentType" className="mb-2" onChange={handleInputChange}>
//               <option value="General">General</option>
//               <option value="Consultation">Consultation</option>
//             </Form.Select>

//             <Form.Select
//               name="slotId"
//               className="mb-2"
//               value={formData.slotId || ''}
//               onChange={(e) => {
//                 const selected = slotOptions.find(o => o.slotId === +e.target.value);
//                 if (selected) {
//                   setFormData({
//                     ...formData,
//                     slotId: selected.slotId,
//                     appointmentDate: selected.appointmentDate,
//                     startTime: selected.startTime,
//                     endTime: selected.endTime,
//                     status: selected.status
//                   });
//                   setSelectedSlotStatus(selected.status);
//                 }
//               }}
//             >
//               <option value="">Select Slot</option>
//               {slotOptions.map(o => (
//                 <option key={o.slotId} value={o.slotId}>
//                   {o.appointmentDate} — {o.startTime}–{o.endTime}
//                 </option>
//               ))}
//             </Form.Select>

//             {selectedSlotStatus && (
//               <div className="alert alert-info p-2">
//                 <strong>Slot Status:</strong> {selectedSlotStatus}
//               </div>
//             )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
//           <Button variant="success" onClick={handleAddAppointment}>Save</Button>
//           <Button
//             variant="success"
//             onClick={formData.id ? handleUpdateAppointment : handleAddAppointment}
//           >
//             {formData.id ? 'Update' : 'Save'}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Attendee Modal */}
//       <Modal show={showAttendeeModal} onHide={() => setShowAttendeeModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Complete Missing Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Select
//               className="mb-2"
//               value={extraDetails.gender}
//               onChange={(e) => setExtraDetails({ ...extraDetails, gender: e.target.value })}
//             >
//               <option value="">Select Gender</option>
//               <option value="Male">Male</option>
//               <option value="Female">Female</option>
//               <option value="Other">Other</option>
//             </Form.Select>
//             <Form.Control
//               type="date"
//               className="mb-2"
//               placeholder="Date of Birth"
//               value={extraDetails.dateOfBirth}
//               onChange={(e) => setExtraDetails({ ...extraDetails, dateOfBirth: e.target.value })}
//             />
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowAttendeeModal(false)}>Cancel</Button>
//           <Button
//             variant="success"
//             onClick={() => {
//               handleAttendee({
//                 ...selectedAppt,
//                 gender: extraDetails.gender,
//                 dateOfBirth: extraDetails.dateOfBirth,
//                 patientAddress: extraDetails.patientAddress
//               });
//               setShowAttendeeModal(false);
//             }}
//           >
//             Save & Continue
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default AppointmentListPage;






import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const AppointmentListPage = () => {
  const navigate = useNavigate();
  const { user, token } = useAuth();
  const doctorId = user?.id;
  const itemsPerPage = 5;

  const [appointments, setAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [search, setSearch] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showAttendeeModal, setShowAttendeeModal] = useState(false);
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [nameFilter, setNameFilter] = useState('');
  const [numberFilter, setNumberFilter] = useState('');
  const [extraDetails, setExtraDetails] = useState({
    gender: '',
    dateOfBirth: '',
    patientAddress: ''
  });
  const [slotOptions, setSlotOptions] = useState([]);
  const [selectedSlotStatus, setSelectedSlotStatus] = useState('');

  const [formData, setFormData] = useState({
    patientFirstName: '',
    patientLastName: '',
    patientEmail: '',
    patientNumber: '',
    patientAddress: '',
    reason: '',
    appointmentType: 'General',
    status: 'Scheduled',
    slotId: '',
    appointmentDate: '',
    startTime: '',
    endTime: '',
    id: null
  });

  const fetchAppointments = async () => {
    try {
      const response = await axios.get(`${API_PATH}/appointments/doctor/${doctorId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const filtered = response.data.filter(appt => !appt.prescriptionDone);
      setAppointments(filtered);
    } catch (err) {
      Swal.fire('Error', 'Failed to fetch appointments', 'error');
    }
  };

  useEffect(() => {
    const loadSlots = async () => {
      try {
        const res = await axios.get(`${API_PATH}/doctors/${doctorId}/schedule/list`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const slots = res.data.flatMap(s =>
          s.appointmentSlots.map(sl => ({
            slotId: sl.slotId,
            scheduleId: s.id,
            appointmentDate: s.scheduleDate,
            startTime: sl.startTime,
            endTime: sl.endTime,
            status: sl.status
          }))
        );
        setSlotOptions(slots);
      } catch (err) {
        Swal.fire('Error', 'Failed to load slots', 'error');
      }
    };

    if (doctorId && token) {
      loadSlots();
      fetchAppointments();
    }
  }, [doctorId, token]);

  const handleAddAppointment = async () => {
    if (!doctorId || !formData.patientNumber || !formData.patientAddress) {
      Swal.fire('Error', 'Please fill all required fields including patient number and address', 'warning');
      return;
    }

    try {
      await axios.post(`${API_PATH}/appointments/book`, {
        ...formData,
        doctorId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      Swal.fire('Success', 'Appointment booked', 'success');
      handleCloseModal();
      fetchAppointments();
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to book appointment', 'error');
    }
  };

  const handleUpdateAppointment = async () => {
    

    
    if (!doctorId || !formData.patientNumber || !formData.patientAddress) {
      Swal.fire('Error', 'Please fill all required fields', 'warning');
      return;
    }

    try {
      await axios.patch(`${API_PATH}/appointments/${formData.id}`, {
        ...formData,
        doctorId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      Swal.fire('Success', 'Appointment updated', 'success');
      handleCloseModal();
      fetchAppointments();
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to update appointment', 'error');
    }
  };

  const handleEditClick = (appointment) => {
    setFormData({
      ...appointment,
      id: appointment.id
    });
    setShowModal(true);
  };

  const handleDeleteAppointment = async (appointmentId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete the appointment!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${API_PATH}/appointments/${appointmentId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        Swal.fire('Deleted!', 'Appointment has been deleted.', 'success');
        fetchAppointments();
      } catch (err) {
        Swal.fire('Error', err.response?.data?.message || 'Failed to delete appointment', 'error');
      }
    }
  };

  useEffect(() => {
    let filtered = appointments.filter(appt => {
      const fullName = `${appt.patientFirstName} ${appt.patientLastName}`.toLowerCase();
      return (
        fullName.includes(search.toLowerCase()) &&
        fullName.includes(nameFilter.toLowerCase()) &&
        appt.patientNumber?.includes(numberFilter)
      );
    });

    if (dateFilter === 'today') {
      filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment(), 'day'));
    } else if (dateFilter === 'tomorrow') {
      filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment().add(1, 'day'), 'day'));
    } else if (dateFilter === 'yesterday') {
      filtered = filtered.filter(appt => moment(appt.appointmentDate).isSame(moment().subtract(1, 'day'), 'day'));
    }

    setFilteredAppointments(filtered);
    setCurrentPage(1);
  }, [appointments, search, nameFilter, numberFilter, dateFilter]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAppointments.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      patientFirstName: '',
      patientLastName: '',
      patientEmail: '',
      patientNumber: '',
      patientAddress: '',
      reason: '',
      appointmentType: 'General',
      status: 'Booked',
      slotId: '',
      appointmentDate: '',
      startTime: '',
      endTime: '',
      id: null
    });
    setSelectedSlotStatus('');
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const ensureSeconds = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
      date.getDate()
    ).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(
      date.getMinutes()
    ).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
  };

  const handleAttendee = async (appt) => {
    try {
      const truncate = (val, limit = 10) => (val ? val.substring(0, limit) : '');
      const response = await axios.post(`${API_PATH}/patients`, {
        firstName: truncate(appt.patientFirstName),
        lastName: truncate(appt.patientLastName),
        dateOfBirth: appt.dateOfBirth || null,
        gender: truncate(appt.gender || extraDetails.gender || 'Unknown'),
        contacts: [
          {
            type: 'Phone',
            value: extraDetails.mobileNumber || appt.patientNumber || ''
          },
          ...(appt.patientEmail ? [{ type: 'Email', value: appt.patientEmail }] : [])
        ],
        registrationDate: ensureSeconds(new Date()),
        attendingDoctorId: doctorId
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const patientId = response.data?.id;
      Swal.fire('Success', 'Patient added successfully', 'success');
      if (patientId) {
        navigate(`/doctor/home/patients/${patientId}/prescriptions`);
      }
    } catch (error) {
      Swal.fire('Error', 'Failed to add patient', 'error');
    }
  };

  return (
    <div className="container p-4 bg-light">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>🗓 Appointments</h4>
        <div className="row w-100">
          <div className="col-md-2">
            <input type="text" className="form-control" placeholder="Filter by Name" value={nameFilter} onChange={(e) => setNameFilter(e.target.value)} />
          </div>
          <div className="col-md-2">
            <input type="text" className="form-control" placeholder="Filter by Number" value={numberFilter} onChange={(e) => setNumberFilter(e.target.value)} />
          </div>
          <div className="col-md-3">
            <input type="date" className="form-control" onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="col-md-2">
            <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} className="form-select">
              <option value="all">All</option>
              <option value="today">Today</option>
              <option value="tomorrow">Tomorrow</option>
              <option value="yesterday">Yesterday</option>
            </select>
          </div>
          <div className="col-md-3">
            <Button onClick={handleShowModal} variant="outline-primary" size="sm" style={{ height: '40px' }}>+ Add Appointment</Button>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead className="tableborder">
            <tr>
              <th>#</th>
              <th>Patient</th>
              <th>Email</th>
              <th>Mobile No</th>
              <th>Time</th>
              <th>Reason</th>
              <th>Address</th>
              <th>Appointment Date</th>
              <th>Type</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((appt, index) => (
              <tr key={appt.id}>
                <td>{indexOfFirstItem + index + 1}</td>
                <td>{`${appt.patientFirstName} ${appt.patientLastName}`}</td>
                <td>{appt.patientEmail}</td>
                <td>{appt.patientNumber}</td>
                <td>{`${appt.startTime} - ${appt.endTime}`}</td>
                <td>{appt.reason}</td>
                <td>{appt.patientAddress}</td>
                <td>{appt.appointmentDate}</td>
                <td><span className="badge bg-info">{appt.appointmentType}</span></td>
                <td><span className={`badge ${appt.status === 'Scheduled' ? 'bg-success' : 'bg-secondary'}`}>{appt.status}</span></td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => handleEditClick(appt)}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    className="ms-2"
                    onClick={() => handleDeleteAppointment(appt.id)}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="outline-success"
                    size="sm"
                    className="ms-2"
                    disabled={appt.prescriptionDone}
                    title={appt.prescriptionDone ? "Prescription already completed" : ""}
                    onClick={() => {
                      const needsExtra = !appt.gender || !appt.dateOfBirth || !appt.patientAddress;
                      if (needsExtra) {
                        setSelectedAppt(appt);
                        setExtraDetails({
                          gender: '',
                          dateOfBirth: '',
                          patientAddress: ''
                        });
                        setShowAttendeeModal(true);
                      } else {
                        handleAttendee(appt);
                      }
                    }}
                  >
                    Attendee
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-center mt-3">
        <Button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} className="me-2">Previous</Button>
        <span>Page {currentPage} of {totalPages}</span>
        <Button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} className="ms-2">Next</Button>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{formData.id ? 'Edit Appointment' : 'Add Appointment'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Control 
              name="patientFirstName" 
              className="mb-2" 
              placeholder="First Name" 
              value={formData.patientFirstName}
              onChange={handleInputChange} 
            />
            <Form.Control 
              name="patientLastName" 
              className="mb-2" 
              placeholder="Last Name" 
              value={formData.patientLastName}
              onChange={handleInputChange} 
            />
            <Form.Control 
              name="patientEmail" 
              type="email" 
              className="mb-2" 
              placeholder="Email" 
              value={formData.patientEmail}
              onChange={handleInputChange} 
            />
            <Form.Control 
              name="reason" 
              className="mb-2" 
              placeholder="Reason" 
              value={formData.reason}
              onChange={handleInputChange} 
            />
            <Form.Control
              name="patientNumber"
              className="mb-2"
              placeholder="Phone Number"
              value={formData.patientNumber}
              onChange={handleInputChange}
              required
            />
            <Form.Control
              name="patientAddress"
              className="mb-2"
              placeholder="Address"
              value={formData.patientAddress}
              onChange={handleInputChange}
              required
            />
            <Form.Select 
              name="appointmentType" 
              value={formData.appointmentType}
              onChange={handleInputChange}
              className="mb-2">
              <option value="General">General</option>
              <option value="Consultation">Consultation</option>
            </Form.Select>

            {/* <Form.Select
              name="slotId"
              className="mb-2"
              value={formData.slotId || ''}
              onChange={(e) => {
                const selected = slotOptions.find(o => o.slotId === +e.target.value);
                if (selected) {
                  setFormData({
                    ...formData,
                    slotId: selected.slotId,
                    appointmentDate: selected.appointmentDate,
                    startTime: selected.startTime,
                    endTime: selected.endTime,
                    status: selected.status
                  });
                  setSelectedSlotStatus(selected.status);
                }
              }}
            >
              <option value="">Select Slot</option>
              {slotOptions.map(o => (
                <option key={o.slotId} value={o.slotId}>
                  {o.appointmentDate} — {o.startTime}–{o.endTime}
                </option>
              ))}
            </Form.Select> */}


            <Form.Select
  name="slotId"
  className="mb-2"
  value={formData.slotId || ''}
  onChange={(e) => {
    const selected = slotOptions.find(o => o.slotId === +e.target.value);
    if (selected) {
      setFormData({
        ...formData,
        slotId: selected.slotId,
        appointmentDate: selected.appointmentDate,
        startTime: selected.startTime,
        endTime: selected.endTime,
        status: selected.status
      });
      setSelectedSlotStatus(selected.status);
    }
  }}
>
  <option value="">Select Slot</option>
 {slotOptions.map(o => (
  <option
    key={o.slotId}
    value={o.slotId}
  >
    {o.appointmentDate} — {o.startTime}–{o.endTime}
    {o.status === 'booked' ? ' (Booked)' : ''}
  </option>
))}
</Form.Select>

            {selectedSlotStatus && (
              <div className="alert alert-info p-2">
                <strong>Slot Status:</strong> {selectedSlotStatus}
              </div>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
          <Button
            variant="success"
            onClick={formData.id ? handleUpdateAppointment : handleAddAppointment}
          >
            {formData.id ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAttendeeModal} onHide={() => setShowAttendeeModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Complete Missing Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Select
              className="mb-2"
              value={extraDetails.gender}
              onChange={(e) => setExtraDetails({ ...extraDetails, gender: e.target.value })}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Form.Select>
            <Form.Control
              type="date"
              className="mb-2"
              placeholder="Date of Birth"
              value={extraDetails.dateOfBirth}
              onChange={(e) => setExtraDetails({ ...extraDetails, dateOfBirth: e.target.value })}
            />
            <Form.Control
              className="mb-2"
              placeholder="Address"
              value={extraDetails.patientAddress}
              onChange={(e) => setExtraDetails({ ...extraDetails, patientAddress: e.target.value })}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAttendeeModal(false)}>Cancel</Button>
          <Button
            variant="success"
            onClick={() => {
              handleAttendee({
                ...selectedAppt,
                gender: extraDetails.gender,
                dateOfBirth: extraDetails.dateOfBirth,
                patientAddress: extraDetails.patientAddress
              });
              setShowAttendeeModal(false);
            }}
          >
            Save & Register
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AppointmentListPage;




